export const features = Object.freeze({
  /** Soft-launch feature flags below: */
  SYNC_LOGGING: 'SYNC_LOGGING',
  PURCHASE_API: 'PURCHASE_API',
  /** Feature is disabled for BigCommerce as we sync customer groups via their own platform */
  CUSTOMER_GROUPS_AMEND: 'CUSTOMER_GROUPS_AMEND',
  TEAM_MEMBER_ROLE: 'TEAM_MEMBER_ROLE',
});

export const platforms = Object.freeze({
  SHOPIFY: 'shopify',
  SHOPIFY_PLUS: 'shopify_plus',
  BIGCOMMERCE: 'bigcommerce',
});

const featureState = Object.freeze({
  [features.SYNC_LOGGING]: {
    enabledForProduction: false,
    enabledSiteIds: [],
  },
  [features.PURCHASE_API]: {
    disabledPlatforms: [platforms.SHOPIFY, platforms.SHOPIFY_PLUS],
  },
  [features.CUSTOMER_GROUPS_AMEND]: {
    disabledPlatforms: [platforms.BIGCOMMMERCE],
  },
  // Hide team member invite role - currently does not do anything
  [features.TEAM_MEMBER_ROLE]: {
    enabledForProduction: false,
  },
});

export const featureEnabled = (featureFlag, siteId, platform = '') => {
  const feature = featureState[featureFlag];
  const isProd = window.location.host === 'app.sparklayer.io';
  let enabled = true;
  if (feature.enabledForProduction === false && isProd) {
    enabled = false;
  }
  if (feature.enabledSiteIds?.includes(siteId)) {
    enabled = true;
  }
  if (platform && feature.disabledPlatforms?.includes(platform)) {
    enabled = false;
  }
  return enabled;
};
